import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CloseButton } from '../buttons';

const useStyles = makeStyles({ name: 'EmobilityPreviewWrapper' })(theme => ({
	paper: {
		background: theme.palette.background.default
	},
	close: {
		position: 'absolute',
		right: 20,
		top: 20
	}
}));

export type EmobilityPreviewWrapperProps = {
	children: React.ReactElement<{ onOpenClick?: () => void }>;
	content: React.ReactElement;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const EmobilityPreviewWrapper = (props: EmobilityPreviewWrapperProps) => {
	const { children, content } = props;
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);
	const { classes: styles } = useStyles(undefined, { props });

	return (
		<React.Fragment>
			{React.cloneElement(children, {
				onOpenClick: () => {
					children.props.onOpenClick?.();
					setIsPreviewOpen(true);
				}
			})}
			<Dialog
				data-test='emobility-preview-dialog'
				keepMounted
				fullScreen
				scroll='paper'
				open={isPreviewOpen}
				onClose={() => setIsPreviewOpen(false)}
				classes={{ paper: styles.paper }}>
				{content}
				<CloseButton
					onClick={() => setIsPreviewOpen(false)}
					className={styles.close} />
			</Dialog>
		</React.Fragment>
	);
};
